import React from "react";
import "./Switch.css";

const Switch = ({ checked, onChange, disabled = false }) => {
  return (
    <label className={`ios-switch ${disabled ? "disabled" : ""}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange && onChange(e.target.checked)}
        disabled={disabled}
      />
      <span className="slider"></span>
    </label>
  );
};

export default Switch;
